export default __webpack_public_path__ + "static/media/inter-light.0cde50f9.woff";